import store from "../../../../../store";
import { rebootRemoteParticipant } from "./remoteParticipants";
import { attemptLaunchVideo } from "./room";
// import { registerConnectTimestamp } from "../timestamps";

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

const AuthStore = store.state.auth; // !!! AuthStore.user IS NOT AVAILABLE HERE, THAT IS WHY WE GET AUTHSTORE ONLY

let room;
let localParticipantStateInterval;
let firstConnectDone = false;

/***************************************
 * LOCAL PARTICIPANT
 ***************************************/
export async function handleLocalParticipant(theRoom, sessionID) {
  room = theRoom;
  /** Connect returns room --> room has 'localParticipant' */
  let localParticipant = room.localParticipant;
  console.log("@handleLocalParticipant: localParticipant: ", localParticipant, sessionID);

  if (localParticipant && localParticipant.identity == AuthStore.user._id) {
    /* Record participant's successful connection to the Cofocus session */
    /** @todo: make CONNECT stamp & account for session end conclusion */
    // await registerConnectTimestamp(user._id, sessionID);

    /* Prepare saving user data for later access */
    let data = {};
    data.localParticipantData = localParticipant;
    const localVideoTrackValues = localParticipant.videoTracks.values();
    data.localVideoTrack = Array.from(localVideoTrackValues)[0].track;

    const localAudioTrackValues = localParticipant.audioTracks.values();
    data.localAudioTrack = Array.from(localAudioTrackValues)[0].track;

    /* Save user's own data for quick access later */
    store.dispatch("room/setLocalParticipantData", data);

    /* Setup handling for the LocalParticipant's events and media changes */
    handleLocalParticipantMedia(localParticipant);
  }
}

/**
 *  @param localParticipant - the publishing LocalParticipant
 *
 * */
function handleLocalParticipantMedia(localParticipant) {
  if (!localParticipant) return;
  console.log("@handleLocalParticipantMedia", localParticipant);

  localParticipantStateInterval = setInterval(() => {
    console.log("localParticipant state: ", localParticipant.state);
  }, 1000);

  /* Handle existing tracks already published by the LocalParticipant. */
  localParticipant.tracks.forEach((localTrackPublication) => {
    handlePublishedLocalTrack(localTrackPublication);
  });

  /* Handle a LocalParticipant having published a new track */
  localParticipant.on("trackPublished", handlePublishedLocalTrack);

  /* A LocalTrack failed to publish */
  localParticipant.on("trackPublicationFailed", handleFailedTrackPublishing);

  /* Handle a LocalParticipant reconnecting */
  localParticipant.on("reconnecting", handleReconnecting);

  /* Handle a LocalParticipant's successful reconnection */
  localParticipant.on("reconnected", handleSuccessfulReconnection);

  /* Handle a LocalParticipant's disconnection */
  localParticipant.on("disconnected", handleLocalDisconnection);

  /* Set the initial Network Quality Level and statistics */
  setInitialNetworkQualityInfo(localParticipant.networkQualityLevel, localParticipant.networkQualityStats);

  /* Handle changes to Network Quality Level and statistics */
  localParticipant.on("networkQualityLevelChanged", handleNetworkQualityChange);
}

/**
 * Handle to the TrackPublication's media.
 * @param localTrackPublication - the TrackPublication
 *
 */
function handlePublishedLocalTrack(localTrackPublication) {
  console.log("@localParticipant published track: ", localTrackPublication);
  if (localTrackPublication && localTrackPublication.track) {
    /* In case of screenshare, don't attach anything. */
    if (localTrackPublication.track.name && localTrackPublication.track.name == "screen") {
      return;
    } else {
      /* Attach LocalParticipant's track to the DOM */
      attachLocalTrack(localTrackPublication.track, localTrackPublication.kind);

      /* Start listening to track states */
      listenToLocalTrackStateChanges(localTrackPublication);
    }
  }
}

/**
 *
 * @param localTrackPublication - the TrackPublication
 *
 */
function listenToLocalTrackStateChanges(localTrackPublication) {
  if (!localTrackPublication) return;
  /** Capture a LOCAL track being turned ON (e.g. user unmutes) */
  localTrackPublication.track.on("enabled", () => {
    console.log("LocalParticipant unmuted");
  });
  /** Capture a LOCAL track being turned OFF(e.g. user mutes audio) */
  localTrackPublication.track.on("disabled", () => {
    console.log("LocalParticipant muted");
  });

  localTrackPublication.track.on("stopped", (localTrack) => {
    console.log("LocalParticipant stopped publishing");
    detachLocalTrack(localTrack);
  });
}

function handleFailedTrackPublishing(error) {
  console.log("@localParticipant failed to publish track", error);
}

function handleReconnecting(localParticipant) {
  if (localParticipant.state !== "reconnecting") return;

  console.log("@localParticipant is reconnecting", localParticipant);

  /* Update the application UI here */
  store.dispatch("sessionState/setStatusMessage", "reconnecting");

  /* Remove RemoteParticipant tracks if exist */
  /**
   * @todo: Remove RemoteParticipant tracks if exist during local reconnect
   * @todo: Add back RemoteParticipant tracks if exist after successful reconnect
   * @todo: Remove RemoteParticipant tracks if Remote is reconnecting? And add back once connected.
   */
}

async function handleSuccessfulReconnection() {
  if (!room) return;
  if (room.state !== "connected") return;
  console.log("@localParticipant has reconnected.");

  /* Update the application UI here */
  if (firstConnectDone && room) {
    await store.dispatch("sessionState/setStatusMessage", "connected");
  } else {
    firstConnectDone = true;
  }

  /**
   * In the case RemoteParticipant refreshed while the LocalParticipant
   * was in a state of reconnecting or disconnected (and therefore did
   * not receive the disconnect signal as the LocalParticipant was
   * essentially offline and therefore also did not remove old tracks
   * of the RemoteParticipant), then it can be necessary to re-initiate
   * the tracks of the RemoteParticipant upon a successful reconnection.
   *
   * Due to Twilio also completely closing down the Room and requiring
   * a complete reboot when one participant completely disconnects,
   * it can also happen during this phase. And hence why if this is not
   * handled and the LocalParticipant disconnects, and therefore the
   * RemoteParticipant also get disconnected (but is then re-initialized),
   * the LocalParticipant won't get the new tracks of the RemoteParticipant.
   */

  /* Attach LocalParticipant's track to the element. */

  /* Ensure latest RemoteParticipant tracks are used */
  await rebootRemoteParticipant(room);
}

export async function handleLocalDisconnection(localParticipant) {
  if (!localParticipant || localParticipant.state !== "disconnected" || room.state !== "disconnected") {
    return;
  }
  console.log("@localParticipant has disconnected: ", localParticipant);

  await store.dispatch("sessionState/setStatusMessage", "disconnected");

  /* Stop all LocalParticipant tracks. */
  stopAllUserTracks();

  if (localParticipant && localParticipant.tracks && localParticipant.tracks.length) {
    localParticipant.tracks.forEach(function (localTrackPublication) {
      if (localTrackPublication.track) {
        detachLocalTrack(localTrackPublication.track);
      }
    });
  }

  if (room) {
    room.disconnect();
  } else if (store.state.room.room) {
    store.state.room.room.disconnect();
  }
  room = null;
  clearInterval(localParticipantStateInterval);
  /* Attempt reconnecting LocalParticipant until successful. */
  await delay(6000); // seems happened too fast and caused duplicate identity error
  await attemptReconnectLocalParticipant();

  /* ENSURE CONNECTING WITH SAME AUDIO VIDEO STATES AS BEFORE */

  /* Make sure to not reset the room here completely,
    as we seek to always keep the connection going,
    therefore we attempt reconnections instead. 
    Previously all was reset and this disrupts the
    session experience. */
}

export function setFirstConnectFalse() {
  firstConnectDone = false;
}

export async function attemptReconnectLocalParticipant() {
  const sessionID = store.state.session.sessionID;
  const fromReconnect = true;
  /* Ensure user is online, else wait until online */
  if (!navigator.onLine) {
    console.log("User not online, retrying in 3...");
    setTimeout(async () => {
      await attemptReconnectLocalParticipant();
    }, 3000);
  } else {
    if (!store.state.sessionState.connected && !room) {
      await attemptLaunchVideo(sessionID, fromReconnect);

      /* If user still not connected */
      if (!store.state.sessionState.connected) {
        setTimeout(async () => {
          await attemptReconnectLocalParticipant();
        }, 5000);
      }
    }
  }
}

export function stopAllUserTracks() {
  const localVideoTrack = store.state.room.localVideoTrack;
  const localAudioTrack = store.state.room.localAudioTrack;

  /* Stop the camera */
  if (localVideoTrack) {
    localVideoTrack.stop();
    // localVideoTrack.srcObject = null;
  }
  if (localAudioTrack) {
    localAudioTrack.stop();
  }
}

function handleNetworkQualityChange(networkQualityLevel, networkQualityStats) {
  console.log(
    {
      1: "▃",
      2: "▃▄",
      3: "▃▄▅",
      4: "▃▄▅▆",
      5: "▃▄▅▆▇",
    }[networkQualityLevel] || ""
  );

  if (networkQualityStats) {
    // Print in console the networkQualityStats, which is non-null only if Network Quality
    // verbosity is 2 (moderate) or greater
    console.log("Network Quality statistics:", networkQualityStats);
  }
}

function setInitialNetworkQualityInfo(networkQualityLevel, networkQualityStats) {
  console.log("Network Quality statistics: ", networkQualityLevel, networkQualityStats);
}

/* ATTACHING & DETACHING TO DOM */

/**
 * Attach a Participant's Track to the DOM.
 * @param localTrack - the Track to attach
 * @param localParticipant - the Participant which published the Track
 */
/* Attach LocalTrackPublication to the DOM */
function attachLocalTrack(localTrack, kind) {
  if (!localTrack || !kind) {
    return console.warn("Local track missing.");
  }

  let container = document.getElementById("local-video");

  /* Attach LocalParticipant's track to the element. */
  if (container) {
    if (container.querySelector(kind) !== null) {
      console.log("already exists");
    } else {
      container.appendChild(localTrack.attach());
    }
    if (store.state.roomLoading.loading) {
      store.dispatch("roomLoading/setLoadingState", false);
    }
  } else {
    console.warn("Something went wrong. Try refreshing the page. If that doesn't resolve your problem, please contact us!");
  }
}

/**
 * Detach a Track from the DOM.
 * @param localTrack - the Track to be detached
 */
export function detachLocalTrack(localTrack) {
  if (!localTrack) return;
  // Detach the Participant's Track from the thumbnail.
  console.log("LocalParticipant track detach", localTrack);
  if (localTrack.kind !== "data") {
    localTrack.detach().forEach((detachedElement) => {
      console.log("detachedElement", detachedElement);
      detachedElement.remove();
    });
  }
}

export default {
  handleLocalParticipant,
  setFirstConnectFalse,
  detachLocalTrack,
};
